// extracted by mini-css-extract-plugin
export var divider = "_30-0";
export var dividerText = "_30-1";